import * as React from "react";
import PropTypes from "prop-types";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";

import MenuItem from "@mui/material/MenuItem";

import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";

import Autocomplete from "@mui/material/Autocomplete";

import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker, TimePicker } from "@mui/x-date-pickers/";
import dayjs from "dayjs";
import "dayjs/locale/ro";
dayjs.locale("ro");

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

function BootstrapDialogTitle(props) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};

export default function SlotDialog({
  open,
  onClose,
  slot,
  onSave,
  onChangeDiag,
  serviceOpt,
  statusOpt,
  doctorOpt,
}) {
  //   console.log(slot?.item?.start);

  return (
    <div>
      {/* <Button variant="outlined" onClick={handleClickOpen}>
        Open dialog
      </Button> */}
      <BootstrapDialog
        onClose={onClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        // maxWidth="md"
        fullWidth
      >
        <BootstrapDialogTitle id="customized-dialog-title" onClose={onClose}>
          {slot?.action.toUpperCase()} SLOT
        </BootstrapDialogTitle>
        <DialogContent dividers>
          {slot && slot.item?.start && (
            <Grid container spacing={2}>
              {slot.slot_name === "blocked_days" && (
                <>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      name="description"
                      label="Days label"
                      helperText="Name of the current day (eg. name of the holiday)"
                      id="description"
                      value={slot.item.description ?? ""}
                      onChange={onChangeDiag}
                    ></TextField>
                  </Grid>
                  <Grid item xs={6}>
                    <LocalizationProvider
                      dateAdapter={AdapterDayjs}
                      adapterLocale="ro"
                    >
                      <DatePicker
                        label="Start Date"
                        name="start"
                        value={dayjs(slot.item.start)}
                        onChange={(newValue) => {
                          onChangeDiag({
                            target: { name: "start", value: newValue },
                          });
                        }}
                        renderInput={(params) => (
                          <TextField {...params} margin="dense" fullWidth />
                        )}
                      />
                    </LocalizationProvider>
                  </Grid>
                  <Grid item xs={6}>
                    <LocalizationProvider
                      dateAdapter={AdapterDayjs}
                      adapterLocale="ro"
                    >
                      <DatePicker
                        label="End Date"
                        name="end"
                        value={dayjs(slot.item.end)}
                        onChange={(newValue) => {
                          onChangeDiag({
                            target: { name: "end", value: newValue },
                          });
                        }}
                        renderInput={(params) => (
                          <TextField {...params} margin="dense" fullWidth />
                        )}
                      />
                    </LocalizationProvider>
                  </Grid>
                </>
              )}
              {slot.slot_name !== "blocked_days" && (
                <>
                  <Grid item xs={6}>
                    <LocalizationProvider
                      dateAdapter={AdapterDayjs}
                      adapterLocale="ro"
                    >
                      <TimePicker
                        label="Start"
                        name="start"
                        value={dayjs()
                          .set("hour", slot.item.start.split(":")[0])
                          .set("minute", slot.item.start.split(":")[1])}
                        onChange={(newValue) => {
                          onChangeDiag({
                            target: { name: "start", value: newValue },
                          });
                        }}
                        renderInput={(params) => (
                          <TextField {...params} margin="dense" fullWidth />
                        )}
                      />
                    </LocalizationProvider>
                  </Grid>
                  <Grid item xs={6}>
                    <LocalizationProvider
                      dateAdapter={AdapterDayjs}
                      adapterLocale="ro"
                    >
                      <TimePicker
                        label="End"
                        name="end"
                        value={
                          slot
                            ? dayjs()
                                .set("hour", slot.item.end.split(":")[0])
                                .set("minute", slot.item.end.split(":")[1])
                            : ""
                        }
                        onChange={(newValue) => {
                          onChangeDiag({
                            target: { name: "end", value: newValue },
                          });
                        }}
                        renderInput={(params) => (
                          <TextField {...params} margin="dense" fullWidth />
                        )}
                      />
                    </LocalizationProvider>
                  </Grid>
                </>
              )}
            </Grid>
          )}
        </DialogContent>
        <DialogActions
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          <Button onClick={onClose}>Cancel</Button>
          <Button onClick={onSave}>Save Slot</Button>
        </DialogActions>
      </BootstrapDialog>
    </div>
  );
}
